<div class="page-loading-container">
    <div *ngIf="showLoadingText" style="margin-bottom:50px">{{ "LoadingTimeIntensive" | translate }}</div>
    <i class="fa fa-spinner fa-spin" ></i>
</div>

